import axios from 'axios';
import { settings } from '@/plugins/settings';

export const b2bInvitesService = {
  fetchByCommunity(communityId: number, page: number = 1, perPage: number = 15): Promise<{ data: any[]; current_page: number; last_page: number; per_page: number; total: number }> {
    return axios({
      url: settings.endpoint + 'b2b-invites',
      method: 'GET',
      params: { community_id: communityId, page, per_page: perPage },
    }).then((response: any) => {
      const outer = response && response.data;
      const d = (outer && outer.data) || outer;
      return {
        data: d && Array.isArray(d.data) ? d.data : [],
        current_page: (d && d.current_page) || 1,
        last_page: (d && d.last_page) || 1,
        per_page: (d && d.per_page) || perPage,
        total: (d && d.total) || 0,
      };
    });
  },

  create(communityId: number, permission: number): Promise<any> {
    return axios({
      url: settings.endpoint + 'b2b-invites',
      method: 'POST',
      data: { community_id: communityId, permission },
    }).then((response: any) => {
      if (response && response.data && response.data.data) return response.data.data;
      return response.data;
    });
  },

  destroy(code: string): Promise<void> {
    return axios({
      url: settings.endpoint + 'b2b-invites/' + code,
      method: 'DELETE',
    }).then(() => {});
  },
};
